var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"renderer",style:({
    width: (_vm.width + "px"),
    height: (_vm.height + "px"),
    minWidth: (_vm.minWidth + "px"),
    minHeight: (_vm.minHeight + "px"),
    backgroundColor: _vm.clearColor
  })},[_c('div',{staticClass:"renderer__inner"},[_c('div',{ref:"rendererCanvas",staticClass:"renderer__canvas",style:({
        transform: ("scale(" + _vm.scale + ")"),
        imageRendering: _vm.imageRendering
      })})]),_c('div',{staticClass:"renderer__components"},[(_vm.renderEcs)?[_vm._l((_vm.entities),function(entity){return [_c(_vm.ecsRenderComponents['VueLogo'],{key:entity.uid,tag:"component",attrs:{"entity":entity}})]})]:_vm._e(),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }